import type { Invoice } from './api/types'

const round2 = (n: number) => Math.round(n * 100) / 100

/** Cash actually posted against the invoice (Σ invoice_payments). */
function posted(inv: Invoice): number {
  return inv.postedAmount ?? 0
}

/** Paid-in-B24 minus posted-to-cash — the amount marked paid but never booked. */
export function unpostedAmount(inv: Invoice): number {
  return round2(Math.max(0, inv.paidAmount - posted(inv)))
}

export function isUnposted(inv: Invoice): boolean {
  // Only `paid` invoices produce a reliable unposted signal: the upsert writes
  // paid_amount = total for paid (regardless of posting), so a failed auto-post
  // shows as paidAmount − postedAmount > 0. For `partial`, paid_amount tracks
  // Σ posted, so the gap is ~0 — those failures are covered by the Telegram
  // alert (notifyUnpostedPayment), not the passive badge.
  return inv.status === 'paid' && unpostedAmount(inv) > 0.01
}

/**
 * Remainder the payment drawer should pre-fill and the backend will accept.
 * Backend outstanding is totalAmount − Σ invoice_payments, so mirror that here
 * (NOT totalAmount − paidAmount, which reads 0 for a marked-paid invoice).
 */
export function outstandingToPost(inv: Invoice): number {
  return round2(Math.max(0, inv.totalAmount - posted(inv)))
}
